import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import PaginationTable from "../../components/Pagination";
import DefaultInput from "../../components/form/DefaultInput";
import {
	Button,
	Divider,
	Image,
	Input,
	Modal,
	Steps,
	Upload,
	UploadFile,
} from "antd";
import classes from "../UnapprovedAccounts/index.module.css";
import { ReactComponent as ExportIcon } from "../../assets/arrow-download-small.svg";
import { ReactComponent as SearchIcon } from "../../assets/search-find.svg";
import { ReactComponent as RejectIcon } from "../../assets/minus-remove-circle.svg";
import { ReactComponent as AcceptIcon } from "../../assets/check-circle.svg";
import { ReactComponent as PrintIcon } from "../../assets/print-icon.svg";
import { UploadOutlined } from "@ant-design/icons";
import { ColDef } from "ag-grid-community";
import { refundStatuses, userRoles } from "../../types/enums";
import Buttons from "../../components/form/Buttons";
import DefaultSelect from "../../components/form/DefaultSelect";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import { valueDateFormatter } from "../../utils/formatters";
import DefaultSwitch from "../../components/form/DefaultSwitch";
import { hasAccess } from "../../lib/MenuValidation";
import { fetchAllUsers } from "../../lib/UserApi";
import useOnDemand from "../../hooks/useOnDemand";
import useLang from "../../hooks/useLang";
import { CONFIG } from "../../config";

const { TextArea } = Input;

interface IRefundInsertData {
	[name: string]: any;
}

const hexToRgba = (hex: string, alpha: number) => {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);
	return `rgba(${r},${g},${b},${alpha})`;
};
const Refunds = () => {
	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
		}),
		[]
	);

	const [tableColumns, setTableColumns] = useState<ColDef[]>();
	const [tableData, setTableData] = useState([]);
	const [code, setCode] = useState<number>();
	const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
	const [openRejectModal, setOpenRejectModal] = useState<boolean>(false);
	const [openRequestModal, setOpenRequestModal] = useState<boolean>(false);
	const [openRefundModal, setOpenRefundModal] = useState<boolean>(false);
	const [openPendingModal, setOpenPendingModal] = useState<boolean>(false);
	const [openReasonModal, setOpenReasonModal] = useState<boolean>(false);
	const [isCompanyExpense, setIsCompanyExpense] = useState<boolean>(true);
	const [openRefundDetailsModal, setOpenRefundDetailsModal] =
		useState<boolean>(false);
	const [staffExpense, setStaffExpense] = useState<boolean>(false);
	const [openShortRefundHistory, setOpenShortRefundHistory] =
		useState<boolean>(false);
	const [name, setName] = useState<string | undefined>();
	// Every user, only for the request window's dropdown: loaded when that window opens instead of
	// on every visit to this page.
	const { data: allUsers, load: loadAllUsers } = useOnDemand(fetchAllUsers);
	const userDropDown = useMemo(
		() =>
			(allUsers ?? [])
				.filter((user: any) => user.userRoleId !== userRoles.CLIENT)
				.map((user: any) => ({
					value: user.id,
					label: `${user.firstName} ${user.lastName} - ${user.userRoleDescription}`,
				})),
		[allUsers]
	);
	const [userId, setUserId] = useState<any | undefined>();
	const [modalDescription, setModalDescription] = useState("");
	const [modalValue, setModalValue] = useState(0);
	const [orderId, setOrderId] = useState<number | undefined>();
	const [refundRequestId, setRefundRequestId] = useState<
		number | undefined
	>();
	const [approvalOrRefusalDescription, setApprovalOrRefusalDescription] =
		useState<string | undefined>("");
	const [refundShortHistory, setRefundShortHistory] = useState<any[]>([]);
	const [refundSelectedFiles, setRefundSelectedFiles] = useState<
		UploadFile[]
	>([]);
	const [imageUrls, setImageUrls] = useState<[]>([]);
	const [refundDetailDecription, setRefundDetailDecription] = useState<
		string | undefined
	>();
	const [reasonDescription, setReasonDescription] = useState<
		string | undefined
	>();
	const [requestedOrderValue, setRequestedOrderValue] = useState<number>(0);
	let grid = useRef(null);

	const canRequestRefund = hasAccess("CREATE_REFUND_REQUEST_ACCESS");
	const canAproveRefundRequest = hasAccess("APPROVE_REFUND_REQUEST_ACCESS");
	const canRefuseRefundRequest = hasAccess("REFUSE_REFUND_REQUEST_ACCESS");
	const canRefundRefundRequest = hasAccess("REFUND_REFUND_REQUEST_ACCESS");

	useEffect(() => {
		setTableColumns([
			// {
			// 	headerCheckboxSelection: true,
			// 	checkboxSelection: true,
			// 	width: 60,
			// },
			{
				field: "id",
				headerName: "Kodi",
				cellStyle: (params: any) => ({
					fontSize: "15px",
					color: "blue",
				}),
				width: 80,
			},
			{
				field: "applicantNameAndSurname",
				headerName: "Emri & Mbiemri i Aplikantit",
				width: 140,
			},
			{
				field: "operatorNameAndSurname",
				headerName: "Operatori qe Rishikon",
				width: 140,
			},
			{
				field: "employeeNameAndSurname",
				headerName: "Emri & Mbiemri i Pergjegjesit",
				width: 140,
			},
			{
				field: "refundStatusDescription",
				headerName: "Statusi",
				cellRendererFramework: (params: any) => {
					const statusColorHexCode =
						params.data.refundStatusColorHexCode || "#ffff";
					const rgbaColor = hexToRgba(statusColorHexCode, 0.08);
					return (
						<div className="flex flex-col items-center">
							<div
								className="statusValues"
								style={{
									backgroundColor: rgbaColor,
									color: statusColorHexCode,
								}}
							>
								<p className="text-lg">&#x2022;</p>
								<p className="w-full">{params.value}</p>
							</div>
							<p className="w-full flex items-center gap-1">
								{/* <DriverIcon /> */}
								<span className="font-normal">
									{params.data.lastHandlerNameAndSurname}
								</span>
							</p>
						</div>
					);
				},
			},
			{
				field: "description",
				headerName: "Pershkrimi",
				width: 230,
			},
			{
				field: "orderDisplayId",
				headerName: "Numri i porosise",
				width: 120,
			},
			{
				field: "documentTypeDescription",
				headerName: "Pershkrimi i dokumentit",
				width: 140,
			},
			{
				field: "createdAt",
				headerName: "Data e aplikimit",
				valueFormatter: (params: any) =>
					valueDateFormatter(params?.value),
				width: 120,
			},
			{
				width: 270,
				// field: "statusId",
				cellRenderer: (params: any) => {
					return (
						<>
							{params?.data
								? renderButtons(
										params.data.statusId,
										params.data
								  )
								: null}
						</>
					);
				},
			},
		]);
		fetchRefunds();
	}, [setTableColumns]);

	const renderButtons = (statusId: number | undefined, data: any | []) => {
		switch (statusId) {
			case refundStatuses.REQUESTED:
			case refundStatuses.INFORMATION_PROVIDED:
				return (
					<div className={classes.buttonsAgGrid}>
						{canRefuseRefundRequest && (
							<Button
								onClick={() => clickOpenRejectModal(data)}
								className={classes.tableButtonFirst}
							>
								<RejectIcon />
								Refuzo
							</Button>
						)}
						{canAproveRefundRequest && (
							<Button
								onClick={() => clickOpenConfirmModal(data)}
								className={classes.tableButtonSecond}
							>
								<AcceptIcon />
								Prano
							</Button>
						)}
						<Button
							onClick={() => clickOpenPendingModal(data)}
							className={classes.tableButtonSecond}
						>
							Kerko info
						</Button>
					</div>
				);
			case refundStatuses.PENDING:
				return (
					<div className={classes.buttonsAgGrid}>
						<Button
							onClick={() => clickOpenReasonModal(data)}
							className={classes.tableButtonSecond}
						>
							Jep info
						</Button>
					</div>
				);
			case refundStatuses.APPROVED:
				return (
					<div className={classes.buttonsAgGrid}>
						{canRefundRefundRequest && (
							<Button
								onClick={() => clickOpenShpagimModal(data)}
								className={classes.tableButtonFirst}
							>
								<RejectIcon />
								Shpagim
							</Button>
						)}
					</div>
				);
			default:
				return null;
		}
	};

	const fetchRefunds = async () => {
		try {
			const response = await api.get("Refund/select-refunds");
			if (response.status === 200) {
				const result = response.data;
				setTableData(result);
			}
		} catch (error) {
			console.log("error", error);
		}
	};

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const totalItems = tableData.length;

	const startOrderIndex = (currentPage - 1) * pageSize + 1;
	const endOrderIndex = Math.min(currentPage * pageSize, totalItems);

	const handlePageChange = (page: any) => {
		setCurrentPage(page);
	};
	const handlePageSizeChange = (current: number, size: number) => {
		setPageSize(size);
		setCurrentPage(1);
	};

	const onBtExport = useCallback(() => {
		if (grid) {
			(grid.current as any).api.exportDataAsExcel();
		}
	}, []);

	const filteredData = useMemo(() => {
		return tableData?.filter((item: any) => {
			return !code || item.id.toString().includes(code);
		});
	}, [code, tableData]);

	const onFirstDataRendered = useCallback((params: any) => {
		(grid.current as any).api.sizeColumnsToFit();
	}, []);

	const openDetailsModal = (rowData: any) => {
		const data = rowData?.data;
		setRefundDetailDecription(data?.description);
		const refundImages = data.refundFileNames?.split(";") ?? [];
		const srcWithImages = refundImages.map(
			(image: any) => `${CONFIG?.BASE_URL}/RefundImages/${image}`
		);
		setImageUrls(srcWithImages);
		setOpenRefundDetailsModal(true);
	};
	const clickOpenConfirmModal = (rowData: any) => {
		const data = rowData;
		setName(data?.applicantNameAndSurname);
		setRefundRequestId(data?.id);
		setOpenConfirmModal(true);
	};
	const clickOpenRejectModal = (rowData: any) => {
		const data = rowData;
		setName(data?.applicantNameAndSurname);
		setRefundRequestId(data?.id);
		setOpenRejectModal(true);
	};

	const clickOpenShpagimModal = (rowData: any) => {
		const data = rowData;
		setOpenRefundModal(true);
		setRefundRequestId(data?.id);
		setOrderId(data?.orderId);
		setRequestedOrderValue(data.value);
	};
	const clickOpenPendingModal = (rowData: any) => {
		const data = rowData;
		setOpenPendingModal(true);
		setRefundRequestId(data?.id);
	};
	const clickOpenReasonModal = (rowData: any) => {
		const data = rowData;
		setOpenReasonModal(true);
		setRefundRequestId(data?.id);
	};

	const validateRequestedData = (data: any) => {
		if (!data.description) {
			toast.error("Pershkrimi eshte i detyrueshem");
			return false;
		}
		if (!data.value) {
			toast.error("Vlerat eshte e detyrueshme");
			return false;
		}
		if (!data.orderId) {
			toast.error("Porosia eshte e detyrueshme");
			return false;
		}
		return true;
	};

	const createRefundRequest = async () => {
		if (refundSelectedFiles.length === 0) {
			toast.error(
				"Ju lutem zgjidhni një ose më shumë fotografi te porosise qe dershironi te shpaguani"
			);
			return;
		}
		const formData = new FormData();
		const extractedFiles = refundSelectedFiles.map(
			(file: any) => file?.originFileObj
		);
		extractedFiles.forEach((file: any) => {
			formData.append("images", file);
		});
		const data: IRefundInsertData = {
			description: modalDescription,
			value: modalValue,
			//employeeId: userId,
			orderId: orderId,
		};

		for (const key in data) {
			formData.append(key, data?.[key]?.toString() ?? "");
		}
		if (validateRequestedData(data)) {
			try {
				const response = await api.post(
					"Refund/refund-request",
					formData
				);
				if (response.status === 200) {
					// const result = response.data;
					toast.success("Insertimi u krye me sukses");
					await fetchRefunds();
					cleanRequestModalState();
				}
			} catch (error) {
				console.log(error);
			}
		} else {
			return;
		}
	};
	const handleRefundRequest = async (
		id: number | undefined,
		statusId: number | undefined,
		description?: string | undefined
	) => {
		if (!description) {
			toast.error(
				"Ju lutem ploteson pershkrimin dhe tregoni arsyen e veprimit!"
			);
			return;
		}
		const data = {
			refundRequestId: id,
			statusId: statusId,
			description: description,
		};
		try {
			const response = await api.post(
				"Refund/update-refund-status",
				data
			);
			if (response.status === 200) {
				await fetchRefunds();
				clearApprovalOrRefusalModalState();
			}
		} catch (error) {
			console.log("An error occurred:", error);
		}
	};

	const acceptRefundRequest = async () => {
		await handleRefundRequest(
			refundRequestId,
			refundStatuses.APPROVED,
			approvalOrRefusalDescription
		);
	};

	const refuseRefundRequest = async () => {
		await handleRefundRequest(
			refundRequestId,
			refundStatuses.REFUSED,
			approvalOrRefusalDescription
		);
	};

	const clearApprovalOrRefusalModalState = () => {
		setApprovalOrRefusalDescription("");
		setRefundRequestId(0);
		setOpenConfirmModal(false);
		setOpenRejectModal(false);
	};

	const handleSwitchChange = (checked: boolean) => {
		setIsCompanyExpense((prevState) => !prevState);
		setStaffExpense((prevState) => !prevState);
	};

	const processRefunds = async () => {
		const data = {
			orderId: orderId,
			statusId: refundStatuses.REFUNDED,
			employeeId: userId,
			refundRequestId: refundRequestId,
			value: modalValue,
		};
		if (!modalValue) {
			toast.error("Vlera eshte e detyrueshme");
			return;
		}
		if (modalValue > requestedOrderValue) {
			toast.error(
				"Vlera nuk mund te jete me e madhe se vlera e kerkeses per shpagim"
			);
			return;
		}
		try {
			const response = await api.post("Refund/process-refund", data);
			if (response.status === 200) {
				await fetchRefunds();
				toast.success("Procesimi dhe shpagimi u perfundua me sukses");
				cleanRefundModalState();
			}
		} catch (error) {
			console.log("Error processing refund:", error);
		}
	};
	const cleanRequestModalState = () => {
		setOrderId(0);
		setModalDescription("");
		setModalValue(0);
		setOpenRequestModal(false);
		setRefundSelectedFiles([]);
	};

	const refundStatusChange = async () => {
		const data = {
			statusId: refundStatuses.PENDING,
			refundRequestId: refundRequestId,
			description: "Kerkohet me teper informata",
		};
		try {
			const response = await api.post(
				"Refund/update-refund-status",
				data
			);
			if (response.status === 200) {
				await fetchRefunds();
				toast.success("Shpagimi u vendos ne pritje per info shtese");
				setOpenPendingModal(false);
			}
		} catch (error) {
			console.log("Error changing status to pending refund:", error);
		}
	};

	const fetchRefundHistory = async (refundRequestId: number) => {
		try {
			const response = await api.get(
				"Refund/select-refund-short-history",
				{ params: { refundRequestId: refundRequestId } }
			);
			if (response.status === 200) {
				setRefundShortHistory(response?.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const saveRefundReasons = async () => {
		if (!reasonDescription) {
			toast.error("Pershkrimi eshte i detyrueshem");
			return;
		}
		const data = {
			statusId: refundStatuses.INFORMATION_PROVIDED,
			refundRequestId: refundRequestId,
			description: reasonDescription,
		};
		try {
			const response = await api.post(
				"Refund/update-refund-status",
				data
			);
			if (response.status === 200) {
				await fetchRefunds();
				toast.success("Informatat shtese u ruajten me sukses");
				cleanReasonModal();
			}
		} catch (error) {
			console.log(error);
		}
	};

	const onCellClicked = async (params: any) => {
		const colId = params.column.colId;
		switch (colId) {
			case "id":
				await onRefundIdClicked(params?.data);
				break;
		}
	};

	const onRefundIdClicked = async (data: any) => {
		fetchRefundHistory(data?.id);
		setOpenShortRefundHistory(true);
	};

	const handleFileChange = (event: any) => {
		if (event.fileList?.length) {
			const file: any = Array.from(event.fileList);
			setRefundSelectedFiles(file);
		}
	};
	const onValueChange = (e: any) => {
		if (parseFloat(e.target.value) < 0) {
			setModalValue(0);
			toast.error("Vlera nuk mund te jete me e vogel se zero");
		} else {
			setModalValue(e.target.value);
		}
	};
	const cleanReasonModal = () => {
		setOpenReasonModal(false);
		setReasonDescription("");
		setModalValue(0);
		setOrderId(0);
	};
	const cleanRefundModalState = () => {
		setModalValue(0);
		setOpenRefundModal(false);
		setIsCompanyExpense(true);
		setStaffExpense(false);
		setUserId(null);
		setRefundRequestId(0);
		setOrderId(0);
		setRequestedOrderValue(0);
	};

	const { strings } = useLang("refunds");

	return (
		<>
			<div className={classes.mainContainer}>
				<div className={classes.heroContainer}>
					<div className={classes.firstContainer}>
						<h1 className={classes.title}>
							{strings?.title} &nbsp;
							<span className={classes.clientsCount}>
								({tableData?.length})
							</span>
						</h1>
						<div className={classes.buttons}>
							<Button
								className={classes.button}
								// onClick={onExportSelectedId}
							>
								<ExportIcon />
								Eksporto
							</Button>
							{canRequestRefund && (
								<Button
									type="primary"
									className={classes.button}
									onClick={() => {
										loadAllUsers();
										setOpenRequestModal(true);
									}}
								>
									<PrintIcon />
									{strings?.requestRefund}
								</Button>
							)}
						</div>
					</div>
					<div className={classes.inputs}>
						<DefaultInput
							label={strings?.search}
							className={classes.input}
							placeholder={strings?.searchCode}
							prefix={<SearchIcon />}
							value={code}
							onChange={(e) => {
								setCurrentPage(1);
								setCode(e.target.value);
							}}
							allowClear
						/>
					</div>
					<div className={classes.pagination}>
						<PaginationTable
							current={currentPage}
							pageSize={pageSize}
							total={totalItems}
							startOrderIndex={startOrderIndex}
							endOrderIndex={endOrderIndex}
							onChange={handlePageChange}
							onShowSizeChange={handlePageSizeChange}
						/>
					</div>
					<div
						className="ag-theme-alpine"
						style={{
							height: 600,
							width: "100%",
						}}
					>
						<AgGridReact
							rowData={filteredData}
							columnDefs={tableColumns}
							defaultColDef={defaultColDef}
							undoRedoCellEditing={true}
							undoRedoCellEditingLimit={20}
							suppressCopyRowsToClipboard={true}
							defaultExcelExportParams={
								defaultExcelExportSettings
							}
							ref={grid}
							enableRangeSelection={true}
							cacheQuickFilter={true}
							onFirstDataRendered={onFirstDataRendered}
							onCellClicked={onCellClicked}
							rowHeight={60}
							onRowDoubleClicked={openDetailsModal}
						/>
					</div>
				</div>
			</div>
			<Modal
				open={openRequestModal}
				title={strings?.requestRefund}
				onCancel={cleanRequestModalState}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={400}
			>
				<Divider />
				<div className="flex flex-col gap-4 items-center">
					<div className="flex flex-col gap-4">
						{/* <DefaultSelect
							label={strings?.inputs.cashRegister.label}
							placeholder={
								strings?.inputs.cashRegister.placeholder
							}
							width={355}
							options={cashRegisterDropDown}
							onChange={(value) =>
								setSelectedCashRegisterId(value)
							}
							allowClear={true}
							value={selectedCashRegisterId}
							onClear={onSelectClear}
							flexDirection="col"
							alignCenter="start"
							className={classes.input}
						/> */}
						<DefaultInput
							label={"Kodi i Porosise"}
							className={classes.input}
							value={orderId}
							onChange={(e) => setOrderId(e.target.value)}
						/>

						<DefaultInput
							label={"Vlera"}
							className={classes.input}
							value={modalValue}
							onChange={onValueChange}
							type="number"
							min={0}
						/>
						<div className={classes.textAreaDiv}>
							<p>
								{
									"Pershkrimi/Informate shtese per kerkesen e shpagimit"
								}
							</p>
							<TextArea
								className={classes.textarea}
								value={modalDescription}
								onChange={(e) =>
									setModalDescription(e.target.value)
								}
							/>
						</div>
						<div className="flex flex-col">
							<label htmlFor="fileInput" className="block mb-2">
								Inserto foto te produktit te demtuar
							</label>
							<Upload
								onChange={handleFileChange}
								multiple={true}
								beforeUpload={() => false}
								accept="image/*"
								fileList={refundSelectedFiles}
							>
								<Button
									icon={<UploadOutlined />}
									className="buttonUploadFile"
								>
									{"Zgjedh foto"}
								</Button>
							</Upload>
						</div>
					</div>
					<Buttons
						button1Text="Mbyll"
						button2Text="Ruaj"
						onButton1Click={cleanRequestModalState}
						onButton2Click={createRefundRequest}
					/>
				</div>
			</Modal>
			<Modal
				open={openConfirmModal}
				onCancel={clearApprovalOrRefusalModalState}
				onOk={acceptRefundRequest}
				title={"Konfirmo Shpagimin"}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<div className="flex flex-col gap-4">
					<p>
						{
							"Ju lutem konfirmoni se deshironi ta pranoni aplikimin e "
						}
						<strong>{name}</strong>.
					</p>
					<div className={classes.textAreaDiv}>
						<p>{"Pershkrimi"}</p>
						<TextArea
							className={classes.textarea}
							value={approvalOrRefusalDescription}
							onChange={(e) =>
								setApprovalOrRefusalDescription(e.target.value)
							}
						/>
					</div>
				</div>
			</Modal>
			<Modal
				open={openRejectModal}
				onCancel={clearApprovalOrRefusalModalState}
				onOk={refuseRefundRequest}
				title={"Refuzo Shpagimin"}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<div className="flex flex-col gap-4">
					<p>
						{
							"Ju lutem konfirmoni se deshironi te refuzoni aplikimin e dhe ta fshini kete aplikim  "
						}
						<strong>{name}</strong>.
					</p>
					<div className={classes.textAreaDiv}>
						<p>{"Pershkrimi/Arsye per refuzim te shpagimit"}</p>
						<TextArea
							className={classes.textarea}
							value={approvalOrRefusalDescription}
							onChange={(e) =>
								setApprovalOrRefusalDescription(e.target.value)
							}
						/>
					</div>
				</div>
			</Modal>
			<Modal
				open={openRefundModal}
				onCancel={cleanRefundModalState}
				onOk={processRefunds}
				title={
					"Ju lutem konfirmoni se deshironi te procesoni shpagimin"
				}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<Divider />

				<div className="flex flex-col gap-4 items-center">
					<p className="font-medium">{`Vlera fillestare e kerkeses per shpagim ka qene: ${requestedOrderValue} ${CONFIG?.CURRENCY}`}</p>
					<DefaultInput
						label={"Vlera"}
						className={classes.input}
						value={modalValue}
						onChange={onValueChange}
						type="number"
					/>
					<div className="flex flex-row  gap-2 items-center">
						<DefaultSwitch
							label={"Shpagim nga kompania"}
							checked={isCompanyExpense}
							onChange={handleSwitchChange}
						/>
						<DefaultSwitch
							label={"Shpagim nga stafi"}
							checked={staffExpense}
							onChange={handleSwitchChange}
						/>
					</div>
					{staffExpense && (
						<DefaultSelect
							label="Safi:"
							flexDirection="col"
							alignCenter="start"
							className={classes.input}
							options={userDropDown}
							onChange={setUserId}
							value={userId}
							allowClear={true}
						/>
					)}

					{/* <p>
                        KUJDES! Ne cilendo zgjedhje te opsionit, do te krijohet nje sh
                    </p> */}
				</div>
			</Modal>
			<Modal
				open={openShortRefundHistory}
				title={"Histori e shkurte e Shpagimit"}
				onCancel={() => setOpenShortRefundHistory(false)}
				onOk={() => setOpenShortRefundHistory(false)}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<Divider />
				<div
					onClick={() =>
						setOpenShortRefundHistory(!openShortRefundHistory)
					}
					className="flex flex-row gap-2"
				>
					{openShortRefundHistory ? <p>{"▼"}</p> : <p>{"▶"}</p>}
					<p>{"Historiku i Shpagimit"}</p>
				</div>
				{openShortRefundHistory && (
					<Steps
						progressDot
						current={10}
						direction="vertical"
						items={refundShortHistory}
					/>
				)}
			</Modal>
			<Modal
				open={openPendingModal}
				onCancel={() => setOpenPendingModal(false)}
				onOk={refundStatusChange}
				title={"Konfirmo qe deshironi te kerkoni me teper informata"}
				okButtonProps={{ className: "bg-blue-500" }}
			>
				{/* <p>{strings?.confirmRemoveOrderFromCollection}</p> */}
			</Modal>
			<Modal
				open={openReasonModal}
				onCancel={cleanReasonModal}
				onOk={saveRefundReasons}
				title={"Ju lutem jepni me shume informata"}
				okButtonProps={{ className: "bg-blue-500" }}
			>
				<>
					<p>{"Pershkrimi  shtese i kerkeses per shpagim"}</p>
					<TextArea
						className={classes.textarea}
						value={reasonDescription}
						onChange={(e) => setReasonDescription(e.target.value)}
					/>
				</>
			</Modal>
			<Modal
				open={openRefundDetailsModal}
				onCancel={() => setOpenRefundDetailsModal(false)}
				// onOk={refundStatusChange}
				title={"Detajet e Shpagimit"}
				okButtonProps={{ style: { display: "none" } }}
				cancelText={"Mbyll"}
			>
				<div>
					<div className="flex flex-col gap-4 pb-4">
						<p>{"Pershkrimi i kerkeses per shpagim"}</p>
						<TextArea
							className={classes.textarea}
							value={refundDetailDecription}
							disabled={true}
							style={{ color: "black" }}
							// onChange={(e) => setModalDescription(e.target.value)}
						/>
					</div>

					{/* <Image.PreviewGroup items={imageUrls}> */}
					{imageUrls?.map((imageUrl, index) => (
						<Image key={index} width={200} src={imageUrl} />
					))}
					{/* </Image.PreviewGroup> */}
				</div>
			</Modal>
		</>
	);
};

export default Refunds;
